import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a7222ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { onBeforeUnmount, ref, watch } from 'vue'
import { pasteCustomClipboardString, pasteExcelClipboardString } from '@/utils/clipboard'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTextarea',
  props: {
    value: { default: '' }
  },
  emits: ["updateValue", "insertExcelData"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const textareaRef = ref<HTMLElement>()
const text = ref('')
const isFocus = ref(false)

// 自定义v-modal，同步数据
// 当文本框聚焦时，不执行数据同步
watch(() => props.value, () => {
  if (isFocus.value) return
  text.value = props.value
  if (textareaRef.value) textareaRef.value.innerHTML = props.value
}, { immediate: true })

const handleInput = () => {
  if (!textareaRef.value) return
  const text = textareaRef.value.innerHTML
  emit('updateValue', text)
}

// 聚焦时更新焦点标记，并监听粘贴事件
const handleFocus = () => {
  isFocus.value = true

  if (!textareaRef.value) return
  textareaRef.value.onpaste = (e: ClipboardEvent) => {
    e.preventDefault()
    if (!e.clipboardData) return

    const clipboardDataFirstItem = e.clipboardData.items[0]

    if (clipboardDataFirstItem && clipboardDataFirstItem.kind === 'string' && clipboardDataFirstItem.type === 'text/plain') {
      clipboardDataFirstItem.getAsString(text => {
        const clipboardData = pasteCustomClipboardString(text)
        if (typeof clipboardData === 'object') return
 
        const excelData = pasteExcelClipboardString(text)
        if (excelData) {
          emit('insertExcelData', excelData)
          if (textareaRef.value) textareaRef.value.innerHTML = excelData[0][0]
          return
        }

        document.execCommand('insertText', false, text)
      })
    }
  }
}

// 失焦时更新焦点标记，清除粘贴事件监听
const handleBlur = () => {
  isFocus.value = false
  if (textareaRef.value) textareaRef.value.onpaste = null
}

// 清除粘贴事件监听
onBeforeUnmount(() => {
  if (textareaRef.value) textareaRef.value.onpaste = null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-textarea",
    ref_key: "textareaRef",
    ref: textareaRef,
    contenteditable: true,
    onFocus: _cache[0] || (_cache[0] = ($event: any) => (handleFocus())),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (handleBlur())),
    onInput: _cache[2] || (_cache[2] = ($event: any) => (handleInput())),
    innerHTML: text.value
  }, null, 40, _hoisted_1))
}
}

})